module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABnSURBVHgB7ZTRCYAwEEOD9F9HuBEcoZuKk7iKI3SDMx9+lGqKoIJIH+TjIBwhBwcI3H2klkymvAGagYq4QIcH+NmSUGm9L2aj98yXsJ/vDtN3OpEwZixiG95M0pYcqb2ClZqzOSnjBlnZcQWFU/SQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/Images/pluseicons.png
// module id = 1128
// module chunks = 0